import { render, staticRenderFns } from "./BrandVehicleDropdown.vue?vue&type=template&id=231733cb"
import script from "./BrandVehicleDropdown.vue?vue&type=script&lang=js"
export * from "./BrandVehicleDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports